import { connect } from "react-redux";
import CancelOrderWindow from "../components/_CancelOrderWindow";
import * as actions from "../../../_actions/order";
import * as miscActions from "../../../_actions/misc";

const mapStateToProps = ({ OrderCancel, Misc }) => ({
    loading: OrderCancel.fetching.loading,
    err: OrderCancel.fetching.err,
    language: Misc.language.language,
    store: Misc.store.store,
    cancelReasons: OrderCancel.Reasons.data || [],
    cancelReasonsLoading: OrderCancel.Reasons.fetch.loading,
    cancelReasonsLoadingError: OrderCancel.Reasons.fetch.err
});

const mapDispatchToProps = dispatch => ({
    cancelOrder: (orderId, cancelOrderData) => {
        dispatch(actions.cancelOrder(orderId, cancelOrderData));
    },
    getOrder: id => {
        dispatch(actions.get(id));
    },
    getCancelReasons: () => {
        dispatch(miscActions.getCancelReasons());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(CancelOrderWindow);



// WEBPACK FOOTER //
// ./src/views/Order/containers/_CancelOrderWindow.js